import { ApiEndPoints, NetworkManager } from "../network";

export class SSMemberServices {
    static getAllSSMembers = () => {
      return NetworkManager.getInstance().appRequest({
        method: "get",
        url: ApiEndPoints.ssMembers
      });
    };

    static addSSMember = (ssMember) => {
      return NetworkManager.getInstance().appRequest({
        method: "post",
        url: ApiEndPoints.ssMembers,
        data: { ...ssMember },
      });
    };

    static updateSSMember= (ssMember) => {
            return NetworkManager.getInstance().appRequest({
              method: "put",
              url: ApiEndPoints.ssMembers,
              data: { ...ssMember },
            });
          };
      static deleteHospital = (id) => {
        return NetworkManager.getInstance().appRequest({
          method: "delete",
          url: ApiEndPoints.hospitals + "/" + id,
          data: { ...id },
        });
      };
      static deleteSSMember = (id) => {
        return NetworkManager.getInstance().appRequest({
          method: "delete",
          url: ApiEndPoints.ssMembers + "/" + id,
          data: { ...id },
        });
      };
}